import Marketing from   "../images/Marketing-Tools-Resources-Optometry.webp"
import Optometry from  "../images/Optometry-EHR-Software-MustHaves.webp"
import  EDGEPro  from "../images/EDGEPro-PracticeAnalytics.webp"


const  News = [
  {
    id: 1,
    cover:  Marketing,
    title: "43 Marketing Tools to Supercharge Your Eye Care Practice",
    descption:"Is your eye care practice struggling to attract, retain, and engage patients? Choosing the right marketing tools makes reaching your business goals much more accessible and puts your practice in overdrive.",
  },
  {
    id: 2,
    cover:  Optometry,
    title: "Top 10 Optometry EHR Software Must-Haves",
    descption:"Are you searching for an optometry EHR that has all the tools you need to maximize efficiency so you can focus on your patients and not on the software? First Insight recently surveyed more than 400 eye care professionals using various EHRs.",
  },
  {
    id: 3,
    cover:  EDGEPro,
    title: "EDGEPro Practice Analytics & MaximEyes Empowers Eye Care Professionals",
    descption:"Every successful practice takes the time to study its strengths and weaknesses to achieve its goals and objectives. That is why MaximEyes.com by First Insight is partnering with EDGEPro by GPN Technologies.",
  },
]

    export default News